module.exports = __webpack_public_path__ + "static/img/159_TO8_1886.10f2e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/159_TO8_1886.jpg
// module id = Zv5s
// module chunks = 0